import { useState } from "react";
import "./Faq.css";

const faqs = [
  {
    q: "What is The Booth?",
    a: "Every week, your ESPN or Sleeper fantasy league gets turned into a full written recap — matchup breakdowns, boom/bust callouts, MVPs, and bench regret, all with the evidence behind each call. Think of it as a sports column, written specifically about your league.",
  },
  {
    q: "How do I use it?",
    a: (
      <ol className="booth-faq-list">
        <li>Create your account</li>
        <li>Add your ESPN or Sleeper league</li>
        <li>Add your leaguemates' emails</li>
        <li>Get the dispatch in your inbox every Tuesday morning</li>
      </ol>
    ),
  },
  {
    q: "Which leagues are supported?",
    a: "Sleeper and public ESPN fantasy football leagues. More platforms are on the way.",
  },
  {
    q: "What does it cost?",
    a: "Free while we're in beta. Add your league and start getting dispatches — no card required.",
  },
];

function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="questions" aria-label="Questions" className="booth-shell booth-faq">
      <h2 className="booth-section-title booth-faq-title">Questions</h2>
      <div className="booth-faq-wrap">
        {faqs.map((item, i) => {
          const expanded = open === i;
          return (
            <div key={item.q} className="booth-faq-item">
              <button
                type="button"
                aria-expanded={expanded}
                onClick={() => setOpen(expanded ? -1 : i)}
                className="booth-faq-question"
              >
                {item.q}
                <span className="booth-faq-icon" aria-hidden="true">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.4">
                    <path d="M1.5 6h9" />
                    {!expanded && <path d="M6 1.5v9" />}
                  </svg>
                </span>
              </button>
              {expanded && <div className="booth-faq-answer">{item.a}</div>}
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default Faq;
